// src/NotFound.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import InlineStyles from './InlineStyles';

const NotFound = () => {
  const navigate = useNavigate();

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#DDDDDD',
      padding: '20px'
    },
    card: {
      background: '#30475E',
      padding: '40px',
      borderRadius: '20px',
      textAlign: 'center',
      color: '#DDDDDD',
      maxWidth: '500px',
      width: '100%',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
    },
    errorCode: {
      fontSize: '72px',
      fontWeight: 'bold',
      color: '#F05454',
      marginBottom: '20px',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    title: {
      fontSize: '28px',
      color: '#F05454',
      marginBottom: '15px'
    },
    message: {
      fontSize: '18px',
      marginBottom: '30px',
      lineHeight: '1.6'
    },
    buttonsContainer: {
      display: 'flex',
      gap: '15px',
      justifyContent: 'center',
      flexWrap: 'wrap'
    },
    button: {
      padding: '12px 24px',
      fontSize: '16px',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      textDecoration: 'none',
      display: 'inline-block'
    },
    primaryButton: {
      backgroundColor: '#007bff',
      color: 'white'
    },
    secondaryButton: {
      backgroundColor: '#6c757d',
      color: 'white'
    }
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <InlineStyles />
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.errorCode}>404</div>
          <h1 style={styles.title}>Page Not Found</h1>
          <p style={styles.message}>
            Sorry, the page you are looking for doesn't exist or has been moved.
          </p>
          <div style={styles.buttonsContainer}>
            <button 
              onClick={handleGoHome}
              style={{...styles.button, ...styles.primaryButton}}
              onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
            >
              Go to ERC Tool
            </button>
            <button 
              onClick={handleGoBack}
              style={{...styles.button, ...styles.secondaryButton}}
              onMouseOver={(e) => e.target.style.backgroundColor = '#5a6268'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#6c757d'}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;